module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.5.2-115.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.5.2.md
// module id = 532
// module chunks = 281